// eslint-disable-next-line simple-import-sort/imports
import 'monitoring/datadog-rum';

import { AppProps } from 'next/app';
import Head from 'next/head';
import React, { useEffect } from 'react';

import '@/styles/globals.css';
import '@nomadhealth/navigation-components/dist/index.css';

import { GoogleTagManagerScript } from '@/components/scripts';
import analytics from '@/analytics';

/**
 * SVGR Support
 * Caveat: No React Props Type.
 *
 * You can override the next-env if the type is important to you
 * @see https://stackoverflow.com/questions/68103844/how-to-override-next-js-svg-module-declaration
 */

/*
Why is the viewport set here and not in _document.tsx?  See: https://nextjs.org/docs/messages/no-document-viewport-meta
 */
function MyApp({ Component, pageProps }: AppProps) {
  useEffect(() => {
    analytics().page();
  }, []);
  return (
    <>
      <Head>
        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
        <meta
          name='google-site-verification'
          content='DZkuZDLmye1A-HoAjyhYp1SdOIFJYOMVKbW0ZlISMXI'
        />
      </Head>
      <GoogleTagManagerScript />
      <Component {...pageProps} />
    </>
  );
}

export default MyApp;
